import type { NavGroup } from "./components/layout/AppShell";

export type AppView =
  | "wallet"
  | "satchel"
  | "designer"
  | "settings"
  | "exchange"
  | "credits"
  | "smart-asset"
  | "scheduling"
  | "buy";

const iconProps = {
  className: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

const assetsIcon = (
  <svg {...iconProps}>
    <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H18a2 2 0 0 1 2 2v1" />
    <path d="M3 7.5V17a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H5.5A2.5 2.5 0 0 1 3 5.5" />
    <circle cx="16.5" cy="13.5" r="1" />
  </svg>
);

const smartAssetsIcon = (
  <svg {...iconProps}>
    <path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Z" />
    <path d="m4 7.5 8 4.5 8-4.5M12 12v9" />
  </svg>
);

const exchangeIcon = (
  <svg {...iconProps}>
    <path d="M7 7h11l-3-3M17 17H6l3 3" />
  </svg>
);

const creditsIcon = (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5v9M9.5 9.75h3.75a1.75 1.75 0 0 1 0 3.5h-2.5a1.75 1.75 0 0 0 0 3.5h3.75" />
  </svg>
);

const settingsIcon = (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.11-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1.04H3a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.56-1.11 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34h.01a1.7 1.7 0 0 0 1.03-1.56V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1.04 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v.01a1.7 1.7 0 0 0 1.56 1.03H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1.04Z" />
  </svg>
);

/** The navigation; prototype features join it only when enabled. */
export function navigationGroups(showPrototypes: boolean): NavGroup<AppView>[] {
  return [
    {
      items: [
        { view: "wallet", label: "Assets", icon: assetsIcon },
        { view: "satchel", label: "Smart Assets", icon: smartAssetsIcon },
      ],
    },
    ...(showPrototypes
      ? [
          {
            label: "Labs",
            items: [
              { view: "designer" as const, label: "Asset designer", icon: smartAssetsIcon },
              { view: "exchange" as const, label: "Exchange", icon: exchangeIcon },
              { view: "credits" as const, label: "SA Credits", icon: creditsIcon },
            ],
          },
        ]
      : []),
    { items: [{ view: "settings", label: "Settings", icon: settingsIcon }] },
  ];
}

/** Views reached from another view keep that view's navigation item highlighted. */
export function navigationViewFor(view: AppView): AppView {
  return view === "smart-asset" || view === "scheduling" ? "designer" : view;
}
